import dayjs from './dayjs';
import { creditCardRoundedIcons } from '../constants/main';
import { CardType } from '../endpoints/customers';

export const getCreditCardIcon = (brand: string) => {
    return creditCardRoundedIcons[brand.replace(' ', '-').toLowerCase() as CardType];
};

export const getCreditCardName = (input: CardType): string => {
    if (typeof input !== 'string') return '';
    return input
        .split('-')
        .map(e => e.charAt(0).toUpperCase() + e.slice(1))
        .join(' ');
};

export const getCreditCardFullExpiryDate = (month: number, year: number) => {
    const m = month < 10 ? '0' + month : month.toString();
    const y = '20' + year.toString();
    return `${m}/${y}`;
};

// A card is valid through the end of its expiry month.
export const isCardExpired = (card: { expiryMonth: number; expiryYear: number }) => {
    const expiryEnd = dayjs(`20${card.expiryYear}-${card.expiryMonth}-01`).endOf('month');
    return dayjs().isAfter(expiryEnd);
};
